import React, { useState } from "react";
import { Button, Card, Col, Form, Input, Row, Spin, message } from "antd";
import { getCustomerLoanDetails } from "./LoanService";
import CustomerLoanDetailsExcel from "../../Utils/Loan/CustomerLoanDetailsExcel";
import { errHandler } from "../../helper/helper";


const CustomerLoanDetails = () => {
    const [customerNo, setCustomerNo] = useState("");
    const [loading, setLoading] = useState(false);

    const generateReport = async () => {
        if (!customerNo.trim()) {
            message.error("Please enter a valid Customer Number");
            return;
        }

        setLoading(true);

        try {
            const res = await getCustomerLoanDetails({
                customerNumber: customerNo.trim(),
                includeAll: true
            });

            const resultData = res?.data || res;

            if (!resultData || (Array.isArray(resultData.loans) && resultData.loans.length === 0)) {
                message.warning("No loan details found for this Customer Number");
                setLoading(false);
                return;
            }

            await CustomerLoanDetailsExcel(resultData, customerNo.trim());
            message.success("Report generated successfully");

        } catch (err) {
            errHandler(err);
        } finally {
            setLoading(false);
        }
    };

    const isGenerateDisabled = loading || !customerNo.trim();

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Customer Number" required>
                                <Input
                                    placeholder="Enter Customer Number"
                                    value={customerNo}
                                    onChange={(e) => setCustomerNo(e.target.value)}
                                    allowClear
                                    onPressEnter={generateReport}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    type="primary"
                                    onClick={generateReport}
                                    disabled={isGenerateDisabled}
                                    className="generate-btn"
                                    size="large"
                                    block
                                >
                                    {loading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default CustomerLoanDetails;